import React from 'react';
import {
  Card,
  Divider,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Switch,
  Typography
} from '@material-ui/core';
import { InfoTooltip } from 'components';
import RequestPromotionDiscountBasicForm from './RequestPromotionDiscountBasicForm';
import RequestPromotionDiscountComplexForm from './RequestPromotionDiscountComplexForm';


const RequestPromotionDiscount = ({
  isFormComplex,
  isFormBasic,
  values,
  handleChange,
  setFieldValue,
  touched,
  errors,
  classes
}) => {
  return (
    <Card className="p-5 mt-4" elevation={0}>
      <Typography variant="h5" className="font-bold mb-5">
        Discount Type <span className="text-error">*</span>
        <InfoTooltip
          title={'Please choose the appropriate discount type. This will determine how the discount will work for this particular promotion.'}
        />
      </Typography>
      <FormControl component="fieldset" className="w-full">
        <RadioGroup
          name="discountType"
          value={values.discountType.value}
          onChange={(event) => {
            setFieldValue('discountType.value', event.target.value);
            Object.keys(values).forEach((key) => {
              if (values[key].hasOwnProperty('isActive') && key === event.target.value) {
                setFieldValue(`${key}.isActive`, true);
              }

              if (values[key].hasOwnProperty('isActive') && key !== event.target.value) {
                setFieldValue(`${key}.isActive`, false);
              }
            });
          }}
        >
          {isFormBasic &&
            <RequestPromotionDiscountBasicForm
              values={values}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              touched={touched}
              errors={errors}
              classes={classes}
            />
          }
          {isFormComplex &&
            <RequestPromotionDiscountComplexForm
              values={values}
              setFieldValue={setFieldValue}
              touched={touched}
              errors={errors}
              classes={classes}
            />
          }
        </RadioGroup>
      </FormControl>
      <Divider className="my-5" />
      <FormControl>
        <FormControlLabel
          control={
            <Switch
              checked={values.freeShipping.isActive}
              name="freeShipping.active"
              color="primary"
              onChange={(event) => {
                setFieldValue('freeShipping.active', event.target.checked);
              }}
            />}
          label="Free Shipping"
        />
      </FormControl>
    </Card>
  );
};

export default RequestPromotionDiscount;
